<template>
  <div class="hero">
    <h1>
      <span class="decorator">::</span>
      <span class="decorator">||</span>
      <br class="break-if-narrow" />
      {{ headTitle }}
      <br class="break-if-narrow" />
      <span class="decorator">||</span>
      <span class="decorator">::</span>
    </h1>
  </div>
</template>

<script setup lang="ts">
interface Props {
  headTitle: string;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
.hero {
  background: $darkGrey;
  color: white;
  display: grid;
  grid-template-columns: 1fr;
  height: 70vh;
  position: relative;
  text-align: center;
  transition: all 0.4s ease-in-out;
  z-index: 1;

  h1 {
    align-self: center;
    animation: 1s ease-in-out 0s 1 slideInFromRight;
    box-sizing: border-box;
    font-size: 1.3rem;
    font-weight: 300;
    justify-self: center;
    letter-spacing: 1rem;
    line-height: 5rem;
    padding-left: 1.6rem;
    text-transform: uppercase;

    span {
      color: $strongPink;
      letter-spacing: 1.5rem;
    }

    .break-if-narrow {
      display: block;

      @media only screen and (min-width: $tbPortrait) {
        display: none;
      }
    }

    @media only screen and (min-width: $tbPortrait) {
      font-size: 1.4rem;
    }

    @media only screen and (min-width: $tbLandscape) {
      font-size: 1.6rem;
    }
  }

  &.home-hero-title {
    // color: $darkest;
    // border-bottom: 1px solid white;
  }
}

@keyframes slideInFromRight {
  0% {
    opacity: 0;
    transform: translate(25%);
  }
  100% {
    opacity: 1;
    transform: translate(0);
  }
}
</style>
